// nsofar doctor-consult contract types (nsofar docs/33 §§2–3 + §7).
//
// nsofar is the SOURCE OF TRUTH for consult state; HCM renders the synced
// `consult` block and drives transitions only via the consult.* webhook
// actions. These types mirror the pinned wire contract — do NOT extend them
// speculatively; contract changes land in nsofar docs/33 first, then here.
//
// Consumed by: apps/api (inbound sr-inbound/sr-update validation + derived
// SR status) and apps/web (Consult Ops queue + SR-detail consult panel).
// nsofar consult lifecycle (docs/32 §8) — wire values, verbatim.
export const CONSULT_STATUSES = [
    "matching",
    "options_sent",
    "payment_pending",
    "selected",
    "confirmed",
    "completed",
    "cancelled",
    "needs_reschedule",
];
export const CONSULT_MODES = ["video", "phone"];
// Selection channel (docs/32 §4; "hcm" added by docs/33 §5.3).
export const CHOSEN_VIA_LABELS = {
    app: "Family (app)",
    whatsapp: "Family (WhatsApp)",
    ops_phone: "nsofar ops (phone)",
    hcm: "HCM console",
};
// §2 display mapping — the coordinator-facing state chip. Deliberately NOT
// new first-class SR statuses (docs/33 §6 Q1, answered in the HCM plan).
export const CONSULT_DISPLAY = {
    matching: "New — find doctors",
    options_sent: "Options with family",
    payment_pending: "Awaiting payment",
    selected: "Book the doctor",
    confirmed: "Booked",
    needs_reschedule: "Re-shortlist",
    completed: "Closed",
    cancelled: "Closed",
};
// Derived coarse HCM SR status, written ONLY by the inbound sync receiver.
// `confirmed` maps to "scheduled" (exact time now known) — NOT HCM's
// "confirmed", which means family-confirmed-after-completion.
export const CONSULT_TO_SR_STATUS = {
    matching: "new",
    options_sent: "new",
    payment_pending: "new",
    needs_reschedule: "new",
    selected: "in_progress",
    confirmed: "scheduled",
    completed: "completed",
    cancelled: "cancelled",
};
// Per-status consult.* actions available to a coordinator (docs/33 §3).
// Auto-confirm requests use the same chained verbs (§7.7) — no special case.
export const CONSULT_ACTIONS_BY_STATUS = {
    matching: ["shortlist"],
    options_sent: ["shortlist", "select_on_behalf"],
    payment_pending: ["payment_link", "needs_reschedule"],
    selected: ["confirm", "needs_reschedule"],
    confirmed: ["join_link", "needs_reschedule", "complete"],
    needs_reschedule: ["shortlist"],
    completed: [],
    cancelled: [],
};
// "YYYY-MM-DDTHH:MM" IST (UTC+05:30, no DST) → UTC Date. Used for the
// confirmed_datetime_ist → scheduled_datetime overwrite (docs/33 §7.5).
export function istToUtc(datetimeIst) {
    return new Date(`${datetimeIst}:00+05:30`);
}
//# sourceMappingURL=consult.js.map